import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { DriveCancelWindow } = await import('@containers/Drive/DriveCancel');
    return {
        Component: DriveCancelWindow,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
